import { ResponsiveTree } from '@nivo/tree'
import {NivoTextTheme} from "./utils";

const NivoTreeChart = ({ data, linkCurve='bump', margin=20 }) => (
    <ResponsiveTree
        theme={NivoTextTheme}
        data={data}
        identity="name"
        activeNodeSize={24}
        inactiveNodeSize={12}
        nodeColor={{ scheme: 'spectral' }}
        nodeSize={12}
        fixNodeColorAtDepth={1}
        linkThickness={1}
        activeLinkThickness={4}
        inactiveLinkThickness={1}
        linkCurve={linkCurve}
        layout="top-to-bottom"
        label={(node) => {
            // Limit label length and stagger based on depth
            if (!node.data.hasOwnProperty('children') || !node?.data?.children?.length > 0) return '';
            return node.data.name;
        }}

        orientLabel={true}
        labelsPosition={'layout-opposite'} // Stagger labels
        labelYOffset={(node) => (node.depth % 2 === 0 ? -10 : 10)} // Adjust Y offset
        labelXOffset={(node) => (node.depth % 2 === 0 ? 10 : -10)} // Adjust X offset
        linkColor={{
            from: 'target.color',
            modifiers: [
                [
                    'opacity',
                    1
                ],
                [
                    'darker',
                    0.1

                ]
            ]
        }}
        margin={{ top: margin, right: margin, bottom: margin, left: margin }}
        motionConfig="stiff"
          mode="dendogram"

        labelsSkipRadius={8}

        meshDetectionRadius={80}
          nodeComponent={function noRefCheck(){}}
          nodeTooltip={function noRefCheck(){}}
          onNodeClick={function noRefCheck(){}}
          onNodeMouseEnter={function noRefCheck(){}}
          onNodeMouseLeave={function noRefCheck(){}}
          onNodeMouseMove={function noRefCheck(){}}

    />
)


export default NivoTreeChart